import React from 'react';

const Spacer = ({height, width}) => {
  return (
    <div style={{height: height, width: width}}></div>
  )
}

export default Spacer